import {FETCH_HOST, POST_INFO} from '../../constants';

function checkStatus(res) {
  if (res.status >= 200 && res.status < 300) {
    return res
  } else {
    const error = new Error(res.statusText);
    error.response = res;
    throw error
  }
}

function parseJSON(res) {
  return res.json();
}

function zyFetch(url, params = {}) {
  const opts = {
    method: 'POST',
    body: JSON.stringify({...POST_INFO, ...params})
  };
  return fetch(`${FETCH_HOST}${url}`, opts)
    .then(checkStatus)
    .then(parseJSON);
}

export {zyFetch};


// WEBPACK FOOTER //
// ./src/tools/lib/zyFetch.js